import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Col, Row } from 'react-bootstrap';
import { BlockInvalidNumber } from '.';

const TipPopup = ( { show, onHide, serviceCost } ) => {
    const [tipValue, setTipValue] = useState('20');
    const [tipsAmount, setTipsAmount] = useState('');
    const [tipError, setTipError] = useState('');
    const [disabledStatus, setDisabledStatus] = useState(true);

    useEffect(() => {
        let getTip = (serviceCost * 20) / 100;
        setTipsAmount((Math.floor(getTip * 100) / 100).toFixed(2));
    }, []);

    const tipHandleChange = ( data ) => {
        setTipValue(data);
        setTipError('');
        
        if ( data !== 'custom' ) {
            setDisabledStatus(true);
            let getTip = (serviceCost * data) / 100;
            setTipsAmount((Math.floor(getTip * 100) / 100).toFixed(2)); 
        } else {
            setDisabledStatus(false);
        }
    }

    const handleAddTip = () => {
        if ( tipsAmount == 0 && tipValue === 'custom' ) {
            setTipError('Please enter valid the tip amount.');
            return;
        }

        onHide(true, Number(tipsAmount)); 
    }

    const popupHandleClose = () => {
        onHide(false, '');
    }

    const setupTipAmount = ( value ) => {
        let roundValue = Math.floor(value);
        let roundValueInString = roundValue.toString().length;

        if ( roundValueInString < 5 ) { 
            let valueSplit = value.split('');
            let getValue = valueSplit.indexOf(".");

            if  (getValue != -1 ) {

                if ( valueSplit.length <= getValue + 3 ) {
                    let amtSplit = value.toString().split('');
                    let roundAmount = amtSplit.join('');
                    setTipsAmount(roundAmount);
                }

            } else {
                let amtSplit = value.toString().split('');           
                let roundAmount = amtSplit.join('');
                setTipsAmount(roundAmount);
            }

        }

    }

    const customTipHandleChange = ( e ) => {
        setTipError('');
        let value = e.target.value.replace(/-\d+/g, ""); 
        let splitValue = value.split('');

        if ( splitValue[0] == '.' || splitValue.length === 0 ) {
            setTipsAmount('');
        } else {
            if ( splitValue[0] == 0 ) {

                if ( splitValue[1] == '.' ) {
                    setupTipAmount(value);
                } else {
                    setTipsAmount(0);
                }

            } else {
                setupTipAmount(value);
            }
        }
    }

    return (
        <Modal show={show} onHide={popupHandleClose} className='custom-modal globalPopup'>
            <Modal.Header closeButton>
                <Modal.Title>Add a Tip</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <Form.Group>
                    <Form.Label>Select a tip amount</Form.Label>
                    <div className='tipRadio popup'>
                        <input type="radio" className='tip' name="tipCheck" label={'15 %'} onChange={() => tipHandleChange('15')} checked={tipValue === '15' ? true : false} />
                        <input type="radio" className='tip' name="tipCheck" label={'20 %'} onChange={() => tipHandleChange('20')} checked={tipValue === '20' ? true : false} />
                        <input type="radio" className='tip' name="tipCheck" label={'25 %'} onChange={() => tipHandleChange('25')} checked={tipValue === '25' ? true : false} />
                        <input type="radio" className='tip' name="tipCheck" label={'Custom'} onChange={() => tipHandleChange('custom')} />
                    </div>
                </Form.Group>

                <Row>
                    <Col md={6}>
                        <Form.Group className="md-3" controlId="formBasicEmail">
                            <Form.Label className='mt-2'>Service Cost</Form.Label>
                            <Form.Control type="text" placeholder="" value={'$'+serviceCost.toFixed(2)} disabled/>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="md-3" controlId="formBasicEmail">
                            <Form.Label className='mt-2'>{disabledStatus ? 'Total Tip' : 'Enter custom tip amount (in $)'}</Form.Label>
                            <Form.Control onKeyDown={BlockInvalidNumber} type="number" name='customAmount' value={tipsAmount} onChange={customTipHandleChange}  disabled={disabledStatus}/>
                        </Form.Group>
                    </Col>
                </Row> 

                <p className='error'>{tipError}</p>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={popupHandleClose}>No, thanks</Button>
                <Button variant="primary" onClick={handleAddTip}>Add</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TipPopup;
